var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SiderMenu',{key:_vm.numberKey,attrs:{"logo":_vm.getLogo,"use-full-logo":"","hideOnCollapsed":true,"menus":_vm.siderMenus,"currentMenu":_vm.currentMenu,"collapsed":_vm.collapsed,"goHome":_vm.goHome,"beforeMenuChange":_vm.beforeMenuChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }